import { IChildProp } from '@intelligence/components/Form/type';

const MARKET_PROFILE_DOWNLOAD_SET: IChildProp[] = [
  {
    enumKey: 'metrics',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    isShowOneText: true,
    children: [
      {
        enumKey: 'rv_mobile',
        enumTargetType: 'metric',
        condition: 'additionalFields:pageId:MarketProfilMobile',
        isDefault: true,
      },
      {
        enumKey: 'dl_mobile',
        enumTargetType: 'metric',
        condition: 'additionalFields:pageId:MarketProfilMobile',
        isDefault: true,
      },
      {
        label: 'Digital Revenue($)',
        labelKey: 'dbi_metric_digitalRevenue',
        value: 'digital_revenue',
        condition:
          'additionalFields:pageId:MarketProfilPC||additionalFields:pageId:MarketProfilConsole',
        isDefault: true,
      },
      {
        label: 'Physical Revenue($)',
        labelKey: 'dbi_metric_physical_revenue',
        value: 'physical_reveßnue',
        condition:
          'additionalFields:pageId:MarketProfilPC||additionalFields:pageId:MarketProfilConsole',
        isDefault: true,
      },
      {
        label: 'Total Revenue(in 2024)',
        // 当labelKey为数组，说明这里是拼凑而成的字符串文本，type为transKey是在组件中进行中英转换的key，variable是从外层携带的参数。
        labelKey: [
          {
            key: 'dbi_total_rev',
            type: 'transKey',
          },
          {
            key: '?additionalFields:yearData',
            type: 'variable',
          },
        ],
        value: 'total_revenue',
        condition:
          'additionalFields:pageId:MarketProfilPC||additionalFields:pageId:MarketProfilConsole',
        isDefault: true,
      },
      {
        label: 'Total Players(in 2024)',
        // 当labelKey为数组，说明这里是拼凑而成的字符串文本，type为transKey是在组件中进行中英转换的key，variable是从外层携带的参数。
        labelKey: [
          {
            key: 'dbi_total_player',
            type: 'transKey',
          },
          {
            key: '?additionalFields:yearData',
            type: 'variable',
          },
        ],
        value: 'total_players',
        condition:
          'additionalFields:pageId:MarketProfilPC||additionalFields:pageId:MarketProfilConsole',
        isDefault: true,
      },
    ],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [
      {
        enumKey: 'timeSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        children: [
          {
            enumKey: 'isTimeAggregated',
            enumTargetType: 'downloadDataCalcu',
          },
          {
            isDefault: true,
            enumKey: 'isSeparateByTime',
            enumTargetType: 'downloadDataCalcu',
          },
        ],
      },
      {
        enumKey: 'regionSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        children: [
          {
            enumKey: 'isCountryAggregated',
            enumTargetType: 'downloadDataCalcu',
          },
          {
            isDefault: true,
            enumKey: 'isSeperateByCountries',
            enumTargetType: 'downloadDataCalcu',
          },
          {
            enumKey: 'isSeperateByRegion',
            enumTargetType: 'downloadDataCalcu',
          },
        ],
      },
      {
        enumKey: 'genreSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        children: [
          {
            isDefault: true,
            enumKey: 'isGenreAggregated',
            enumTargetType: 'downloadDataCalcu',
          },
          {
            enumKey: 'isByGenre',
            enumTargetType: 'downloadDataCalcu',
          },
          {
            enumKey: 'isBySubGenre',
            enumTargetType: 'downloadDataCalcu',
          },
        ],
      },
      {
        enumKey: 'ratio',
        enumTargetType: 'downloadMainCategory',
        type: 'switch',
        isDefault: true,
      },
    ],
  },
  {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'exportAllData',
        enumTargetType: 'downloadOther',
        isDefault: true,
      },
      {
        enumKey: 'selectTop',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportSpecialSelected',
        enumTargetType: 'downloadOther',
      },
    ],
  },
  {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  },
  {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  },
];

const MARKET_PROFILE_MOBILE_DOWNLOAD_SET: IChildProp[] = [
  {
    enumKey: 'metrics',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    isShowOneText: false,
    children: [
      {
        enumKey: 'rv_mobile',
        enumTargetType: 'metric',
        condition: 'additionalFields:pageId:MarketProfilMobile',
        isDefault: true,
      },
      {
        enumKey: 'dl_mobile',
        enumTargetType: 'metric',
        condition: 'additionalFields:pageId:MarketProfilMobile',
        isDefault: true,
      },
      {
        label: 'Digital Revenue($)',
        labelKey: 'dbi_metric_digitalRevenue',
        value: 'digital_revenue',
        condition:
          'additionalFields:pageId:MarketProfilPC||additionalFields:pageId:MarketProfilConsole',
        isDefault: true,
      },
      {
        label: 'Physical Revenue($)',
        labelKey: 'dbi_metric_physical_revenue',
        value: 'physical_reveßnue',
        condition:
          'additionalFields:pageId:MarketProfilPC||additionalFields:pageId:MarketProfilConsole',
        isDefault: true,
      },
      {
        label: 'Total Revenue(in 2024)',
        // 当labelKey为数组，说明这里是拼凑而成的字符串文本，type为transKey是在组件中进行中英转换的key，variable是从外层携带的参数。
        labelKey: [
          {
            key: 'dbi_total_rev',
            type: 'transKey',
          },
          {
            key: '?additionalFields:yearData',
            type: 'variable',
          },
        ],
        value: 'total_revenue',
        condition:
          'additionalFields:pageId:MarketProfilPC||additionalFields:pageId:MarketProfilConsole',
        isDefault: true,
      },
      {
        label: 'Total Players(in 2024)',
        // 当labelKey为数组，说明这里是拼凑而成的字符串文本，type为transKey是在组件中进行中英转换的key，variable是从外层携带的参数。
        labelKey: [
          {
            key: 'dbi_total_player',
            type: 'transKey',
          },
          {
            key: '?additionalFields:yearData',
            type: 'variable',
          },
        ],
        value: 'total_players',
        condition:
          'additionalFields:pageId:MarketProfilPC||additionalFields:pageId:MarketProfilConsole',
        isDefault: true,
      },
    ],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [
      {
        enumKey: 'timeSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        children: [
          {
            enumKey: 'isTimeAggregated',
            enumTargetType: 'downloadDataCalcu',
          },
          {
            isDefault: true,
            enumKey: 'isSeparateByTime',
            enumTargetType: 'downloadDataCalcu',
          },
        ],
      },
      {
        enumKey: 'regionSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        children: [
          {
            enumKey: 'isCountryAggregated',
            enumTargetType: 'downloadDataCalcu',
          },
          {
            isDefault: true,
            enumKey: 'isSeperateByCountries',
            enumTargetType: 'downloadDataCalcu',
          },
          {
            enumKey: 'isSeperateByRegion',
            enumTargetType: 'downloadDataCalcu',
          },
        ],
      },
      {
        enumKey: 'genreSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        children: [
          {
            isDefault: true,
            enumKey: 'isGenreAggregated',
            enumTargetType: 'downloadDataCalcu',
          },
          {
            enumKey: 'isByGenre',
            enumTargetType: 'downloadDataCalcu',
          },
          // {
          //   enumKey: 'isBySubGenre',
          //   enumTargetType: 'downloadDataCalcu',
          // },
        ],
      },
      {
        enumKey: 'ratio',
        enumTargetType: 'downloadMainCategory',
        type: 'switch',
        isDefault: true,
      },
    ],
  },
  {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'exportAllData',
        enumTargetType: 'downloadOther',
        isDefault: true,
      },
      {
        enumKey: 'selectTop',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportSpecialSelected',
        enumTargetType: 'downloadOther',
      },
    ],
  },
  {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  },
  {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  },
];

const MARKET_PROFILE_STATS_DOWNLOAD_SET: IChildProp[] = [
  {
    enumKey: 'gamePlatform',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'mobileGame',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:entityType:mobile',
      },
      {
        enumKey: 'pcGame',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:entityType:pc',
      },
      {
        enumKey: 'consoleGame',
        enumTargetType: 'gameCategory',
        defaultSelectCondition: 'additionalFields:entityType:console',
      },
    ],
  },
  {
    enumKey: 'dataCategory',
    enumTargetType: 'downloadMainCategory',
    type: 'checkboxGroup',
    children: [
      {
        enumKey: 'operation',
        enumTargetType: 'dataCategory',
        defaultSelectCondition: 'additionalFields:dataType:operation',
      },
      {
        enumKey: 'byGames',
        enumTargetType: 'dataCategory',
        defaultSelectCondition: 'additionalFields:dataType:game',
      },
      {
        enumKey: 'byMainGenre',
        enumTargetType: 'dataCategory',
        defaultSelectCondition: 'additionalFields:dataType:genre',
      },
      {
        enumKey: 'bySubGenre',
        enumTargetType: 'dataCategory',
        defaultSelectCondition: 'additionalFields:dataType:genre',
      },
      {
        enumKey: 'byCompanies',
        enumTargetType: 'dataCategory',
        defaultSelectCondition: 'additionalFields:dataType:company',
      },
    ],
  },
  {
    enumKey: 'dataCalculation',
    enumTargetType: 'downloadMainCategory',
    type: 'subForm',
    className: 'form-item--top-18',
    children: [
      {
        enumKey: 'timeSettings',
        enumTargetType: 'downloadMainCategory',
        type: 'radio',
        children: [
          {
            enumKey: 'isTimeAggregated',
            enumTargetType: 'downloadDataCalcu',
            isDefault: true,
          },
          {
            enumKey: 'isSeparateByTime',
            enumTargetType: 'downloadDataCalcu',
          },
        ],
      },
      {
        enumKey: 'ratio',
        enumTargetType: 'downloadMainCategory',
        type: 'switch',
        isDefault: true,
      },
    ],
  },
  {
    enumKey: 'dataAmount',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        enumKey: 'exportAllData',
        enumTargetType: 'downloadOther',
        isDefault: true,
      },
      {
        enumKey: 'selectTop',
        enumTargetType: 'downloadOther',
      },
    ],
  },
  {
    enumKey: 'selectTop',
    enumTargetType: 'downloadMainCategory',
    type: 'inputNumber',
    // 默认值，带?为变量传入，不带为正常值
    defaultValue: '?additionalFields:initialSelectTop',
    condition: 'dataAmount:top',
  },
  {
    enumKey: 'fileFormat',
    enumTargetType: 'downloadMainCategory',
    type: 'radio',
    children: [
      {
        isDefault: true,
        enumKey: 'exportExcel',
        enumTargetType: 'downloadOther',
      },
      {
        enumKey: 'exportCSV',
        enumTargetType: 'downloadOther',
      },
    ],
  },
];

export default {
  marketProfile: MARKET_PROFILE_DOWNLOAD_SET,
  mobileMarketProfileTopCharts: MARKET_PROFILE_MOBILE_DOWNLOAD_SET,
  marketProfileStats: MARKET_PROFILE_STATS_DOWNLOAD_SET,
};
